import React from "react";
import ReactDOM from "react-dom/client";
import { Auth0Provider } from '@auth0/auth0-react';
import App from "./App";
// import "./index.css";
import "./styles/global.scss"
import { BrowserRouter as Router } from "react-router-dom";
import { OriginProvider } from "./context/OriginContext";
import { ProfileProvider } from "./context/ProfileContext";
import { ThemeProvider } from "./context/ThemeContext";


ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <Auth0Provider
            domain={process.env.REACT_APP_AUTH0_DOMAIN!}
            clientId={process.env.REACT_APP_AUTH0_CLIENT_ID!}
            authorizationParams={{
                redirect_uri: `${window.location.origin}/chat`,
            }}
        >
            <ThemeProvider>
                <OriginProvider>
                    <ProfileProvider>
                        <Router>
                            <App />
                        </Router>
                    </ProfileProvider>
                </OriginProvider>
            </ThemeProvider>
        </Auth0Provider>
    </React.StrictMode>
);
